import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitClicked())),
    class: _normalizeClass(_ctx.buttonClass)
  }, [
    _createElementVNode("strong", null, _toDisplayString(_ctx.text), 1)
  ], 2))
}